import { render, staticRenderFns } from "./copyrightAudio.vue?vue&type=template&id=0485214a&scoped=true&"
import script from "./copyrightAudio.vue?vue&type=script&lang=js&"
export * from "./copyrightAudio.vue?vue&type=script&lang=js&"
import style0 from "./copyrightAudio.vue?vue&type=style&index=0&id=0485214a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485214a",
  null
  
)

export default component.exports